module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_3_4.638879a0.png";